import { ReactDatePicker } from '../ReactDatePicker/ReactDatePicker'
import css from './DatePickerRange.module.scss'

export const DatePickerRange = ({
	endDate,
	onChangeEndDate,
	onChangeStartDate,
	startDate
}: {
	endDate?: Date
	onChangeEndDate: (date: Date) => void
	onChangeStartDate: (date: Date) => void
	startDate?: Date
}) => (
	<div className={css.root}>
		<ReactDatePicker
			endDate={endDate}
			maxDate={endDate}
			onChange={date => date instanceof Date && onChangeStartDate(date)}
			placeholder='From'
			selected={startDate}
			selectsStart
			startDate={startDate}
		/>
		<ReactDatePicker
			endDate={endDate}
			minDate={startDate}
			onChange={date => date instanceof Date && onChangeEndDate(date)}
			placeholder='To'
			popperPlacement='bottom-end'
			selected={endDate}
			selectsEnd
			startDate={startDate}
		/>
	</div>
)
